document.addEventListener('DOMContentLoaded', () => {
	const mainBarElement = document.getElementById('main-bar');
	const navToggleElement = document.getElementById('nav-toggle');
	const cookieNoticeElement = document.getElementById('cookie-notice');
	const gaInitiated = false;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}
	function deleteCookie(cname) {
		const d = new Date();
		d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=;' + expires + ';path=/';
	}
	function getCookie(cname) {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
	let cookieConsent = getCookie('cookie_consent');
	if (cookieNoticeElement && cookieConsent != '') {
		cookieNoticeElement.style.display = 'none';
	}
	function acceptCookies() {
		deleteCookie('cookie_consent');
		setCookie('cookie_consent', 1, 30);
		cookieNoticeElement.className = 'notice-hide';
	}

	function showNumber(el, str) {
		e = document.getElementById(el);
		e.innerHTML = str;
		if (gaInitiated) {
			ga('send', 'event', 'odsloniecie', el, str);
			console.log(
				'Wysłanie eventu do GA: (odsloniecie), (' + el + '), (' + str + ')'
			);
		}
	}


	function toggleNav() {
		if(mainBarElement.classList.contains('nav-visible')){
			mainBarElement.classList.remove('nav-visible');
		}else{
			mainBarElement.classList.add('nav-visible');
		}
	}

	function toggleNavTransparency() {
		if (mainBarElement) {
			if (window.scrollY > 10) mainBarElement.classList.remove('nav-transparent');
			if (window.scrollY < 5) mainBarElement.classList.add('nav-transparent');
		}
	}

	function asyncScript(u, o) {
		var e = document.createElement('script');
		e.type = 'text/javascript';
		e.async = true;
		e.src = u;
		e.onload = o;
		var n = document.getElementsByTagName('script')[0];
		n.parentNode.insertBefore(e, n);
	}

	function asyncStyle(u) {
		var e = document.createElement('link');
		e.rel = 'stylesheet';
		e.href = u;
		var n = document.getElementsByTagName('link')[0];
		n.parentNode.insertBefore(e, n);
	}

	function visCheck() {
		this.objectArray = [];

		this.checkCallback = function (target) {
			const io = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('visible');
						} else {
							entry.target.classList.remove('visible');
						}
					});
				},
				{ threshold: [0.2] }
			);
			io.observe(target);
		};

		this.init = function () {
			var mainObj = document.querySelector('main');
			var children = mainObj.children;
			this.objectArray = Array.from(children);
			this.objectArray.forEach(this.checkCallback);
		};
	}

	function lazyLoad() {
		this.objectArray = [];

		this.lazyCallback = (target) => {
			const io = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (!entry.target.classList.contains('loaded')) {
								if (entry.target instanceof HTMLPictureElement) {
									var children = entry.target.children;
									var children = Array.from(children);
									children.forEach((child) => {
										if (child.hasAttribute('data-src'))
											child.setAttribute('src', child.getAttribute('data-src'));
										if (child.hasAttribute('data-srcset'))
											child.setAttribute('srcset', child.getAttribute('data-srcset'));
									});
								}
								entry.target.classList.add('loaded');
							}
							entry.target.classList.add('visible');
						} else {
							entry.target.classList.remove('visible');
						}
					});
				},
				{ threshold: [0.01] }
			);
			io.observe(target);
		};

		this.init = function () {
			var lazyObjects = document.getElementsByClassName('lazy');
			for (const obj of lazyObjects) {
				this.objectArray.push(obj);
				this.objectArray.forEach(this.lazyCallback);
			}
		};
	}

	function slideInit(e, t, i) {
		var a = document.getElementById(e);
		(a.dataset.isScrolling = 0),
			null != i && (a.dataset.imageSwitch = '1'),
			a.addEventListener(
				'scroll',
				function (i) {
					clearTimeout(a.dataset.isScrolling),
						(a.dataset.isScrolling = setTimeout(function () {
							(a.dataset.activeSlide = Math.round(a.scrollLeft / a.offsetWidth)),
								slideTo(e, null, t);
						}, 500));
				},
				!1
			),
			slideTo(e, 0, t),
			(window.onresize = function () {
				slideTo(e, null, t);
			});
	}
	function slideTo(e, t, i) {
		var a = document.getElementById(e);
		null != t
			? (a.dataset.activeSlide = t)
			: (t = parseInt(a.dataset.activeSlide)),
			null != a.dataset.timer && clearTimeout(parseInt(a.dataset.timer)),
			(a.scrollLeft = a.offsetWidth * t),
			slideLinks(e, t),
			(a.dataset.timer = setTimeout(function () {
				slideTo(e, (t + 1) % i, i);
			}, 1e4));
	}
	function slideLinks(e, t) {
		var i = document.getElementById(e),
			a = document.getElementById(e + '-buttons');

		for (var d = 0; d < a.children.length; d++) {
			a.children[d].classList.remove('active');
			i.children[d].classList.remove('active');
		}
		a.children[t].classList.add('active');
		i.children[t].classList.add('active');
	}

	window.addEventListener('scroll', toggleNavTransparency);
	navToggleElement.addEventListener('click', toggleNav);

	window.addEventListener('load', toggleNavTransparency);
	window.addEventListener('load', asyncStyle('/inc/base-async.css?v=6'));
	//window.addEventListener('load',asyncScript('https://www.google.com/recaptcha/api.js?render=6LfSmsIUAAAAAPpqA99zH99XNB06qKqpip9n6dU-'));
	window.addEventListener('load', () => {
		var lazyLoader = new lazyLoad();
		var visChecker = new visCheck();
		if (
			!('IntersectionObserver' in window) ||
			!('IntersectionObserverEntry' in window) ||
			!('intersectionRatio' in window.IntersectionObserverEntry.prototype)
		) {
			asyncScript(
				'https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver',
				() => {
					lazyLoader.init();
					visChecker.init();
				}
			);
		} else {
			lazyLoader.init();
			visChecker.init();
		}

		// setTimeout(() => {
		// 	(function (i, s, o, g, r, a, m) {
		// 		i['GoogleAnalyticsObject'] = r;
		// 		(i[r] =
		// 			i[r] ||
		// 			function () {
		// 				(i[r].q = i[r].q || []).push(arguments);
		// 			}),
		// 			(i[r].l = 1 * new Date());
		// 		(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
		// 		a.async = 1;
		// 		a.src = g;
		// 		m.parentNode.insertBefore(a, m);
		// 	})(
		// 		window,
		// 		document,
		// 		'script',
		// 		'https://www.google-analytics.com/analytics.js',
		// 		'ga'
		// 	);
		// 	ga('create', 'UA-105324618-1', 'auto');
		// 	ga('send', 'pageview');
		// 	gaInitiated = true;
		// }, 3000);
	});
});
